import React from "react";
import   "../../../../../App.scss";

interface Props {
    footer?: React.ReactNode;
}

export class Body extends React.Component<React.PropsWithChildren<Props>> {
    render() {
        return (
            <div className="payment-page-section payment-page-body">
                <div className="content-inner-wrapper payment-page-body-content">
                    {this.props.children}
                </div>
                {this.props.footer && (
                    <div className="content-inner-wrapper payment-page-body-footer">
                        {this.props.footer}
                    </div>
                )}
            </div>
        );
    }
}
